"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontNames = void 0;
// use an object here, to be able to iterate through and also build a type from
exports.FontNames = {
    default: null,
    Gotham4r: null,
    Gotham7r: null,
    GothamSSm3r: null,
    GothamSSm4r: null,
    GothamSSm5r: null,
    GothamSSm7r: null,
    GothamNarrow: null,
    OpenSans: null,
    OpenSansBold: null,
    OttoSans: null,
    OttoSansBold: null,
    OttoSansThin: null,
    KalamBold: null,
    PoppinsLight: null,
    PoppinsRegular: null,
    PoppinsBold: null,
    PoppinsMedium: null,
    PoppinsSemibold: null,
};
//# sourceMappingURL=cmsdata.js.map